import {Component, Inject, LOCALE_ID, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {FormStyle, getLocaleDayNames, TranslationWidth} from '@angular/common';
import {Constants} from '../../../constants';
import {SchedulingService} from '../../../modules/scheduling/scheduling.service';
import {Globals} from '../../../globals';

@Component({
  selector: 'app-tdo-mini-calendar',
  templateUrl: './tdo-mini-calendar.component.html',
  styleUrls: ['./tdo-mini-calendar.component.scss']
})
export class TdoMiniCalendarComponent implements OnInit {
  @Input() daysToHighlight: number[] = [];
  @Output() selectedDateChange = new EventEmitter<Date>();

  @Input() isGetAppointmentDays: boolean = false;

  localeDaysOfWeek!: readonly string[];
  formattedDaysOfWeek: string[] = [];

  todayDate = new Date(Date.now());
  selectedDate: Date;
  hoveredDayNum: number = 0;

  numDaysInSelectedMonth: number[];
  firstDayOfMonth: string;
  appointments: any[] = [];
  isShowMonthAndYearPicker = false;

  months: string[];
  minYear: number;
  maxYear: number;
  years: number[] = [];

  constructor(@Inject(LOCALE_ID) private localeId: string, private schedulingService: SchedulingService, private globals: Globals ) { }

  ngOnInit(): void {
    console.log("Calendar onInit");
    const t = new Date();
    this.maxYear = t.getFullYear() + 7;
    this.minYear = t.getFullYear() - 5;

    for (let i = this.minYear; i < this.maxYear; i++) {
      this.years.push(i);
    }

    this.months = Constants.monthNamesAbbreviated;
    // const narrowDaysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    this.localeDaysOfWeek = getLocaleDayNames(this.localeId, FormStyle.Format, TranslationWidth.Narrow);
    /*this.localeDaysOfWeek = getLocaleDayNames(this.localeId, FormStyle.Format, TranslationWidth.Abbreviated);
    for (const d of this.localeDaysOfWeek) {
      console.log('d: ' + d);
      console.log('D: ' + d.toUpperCase());
      this.formattedDaysOfWeek.push(d.toUpperCase());
    }*/

    this.selectedDate = this.todayDate;
    this.getAppointmentDates();
    this.selectedDateChange.emit(this.selectedDate);
    this.changeMonth();
  }

  getAppointmentDates() {
    console.log("Calendar getAppointmentDates");
    if (this.isGetAppointmentDays) {
      const todayDate = this.selectedDate;
      const startDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
      const endDate = new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0);

      const dateRange: string = this.formatDate(startDate) + ' ' + this.formatDate(endDate);
      this.schedulingService.getAppointmentsMinimum(this.globals.LOCID, dateRange).subscribe((appts) => {
        this.appointments = appts;
        this.daysToHighlight = this.appointments.map(p => {
          const date = new Date(p.StartDate);
          return date.getDate();
        });
      });
    }
  }

  formatDate(date) {
    // tslint:disable-next-line:one-variable-per-declaration prefer-const
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      // tslint:disable-next-line:prefer-const
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  onTodayClick() {
    console.log("Calendar todayclick");
    this.selectedDate = this.todayDate;
    this.changeMonth();
    this.selectedDateChange.emit(this.selectedDate);
  }

  getCurrentMonthName() {
    return Constants.monthNames[this.selectedDate.getMonth()];
  }

  changeDate(dayNum: number) {
    console.log("Calendar changedate");
    this.selectedDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), dayNum);
    this.selectedDateChange.emit(this.selectedDate);
  }

  changeMonth() {
    console.log("Calendar changemonth");
    let month: number = this.selectedDate.getMonth();
    let year = this.selectedDate.getFullYear();
    /*if (month < 11) {
      // month += 1;
    } else {
      month = 0;
      year += 1;
    }*/
    const numDays = new Date(year, month + 1, 0).getDate();
    this.numDaysInSelectedMonth = [];
    for (let i = 1; i <= numDays; i++) {
      this.numDaysInSelectedMonth.push(i);
    }

    this.firstDayOfMonth = Constants.weekDays[new Date(year, month, 1).getDay()].toLowerCase();
  }

  isSelectedWeekday(dayNum: number) {
    return this.selectedDate.getDate() === dayNum;
  }

  isHoveredWeekday(dayNum: number) {
    return this.hoveredDayNum === dayNum;
  }

  isHighlightedDay(day: number) {
    return this.daysToHighlight.includes(day);
  }

  onSelectMonthOrYear() {
    this.isShowMonthAndYearPicker = true;
  }

  onClickOutsideMonthYearPicker() {
    this.isShowMonthAndYearPicker = false;

    this.saveChangeToMonthOrYear();
  }

  saveChangeToMonthOrYear() {
    this.changeMonth();
    // this.selectedDateChange.emit(this.selectedDate);
  }

  isSelectedMonth(i: number) {
    return this.selectedDate.getMonth() === i;
  }

  isSelectedYear(year: number) {
    return this.selectedDate.getFullYear() === year;
  }

  onMonthClick(i: number) {
    // this.selectedDate.setMonth(i);
    this.selectedDate = new Date(this.selectedDate.getFullYear(), i);
    this.changeMonth();
    this.getAppointmentDates();
    this.selectedDateChange.emit(this.selectedDate);
    // console.log('test');
  }

  onYearClick(year: number) {
    console.log("Calendar yearclick");
    this.changeMonth();
    this.selectedDate.setFullYear(year);
    this.getAppointmentDates();
    this.selectedDateChange.emit(this.selectedDate);
  }

  updateLocation(LOCID: string) {
    const todayDate = this.selectedDate;
    const startDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
    const endDate = new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0);

    const dateRange: string = this.formatDate(startDate) + ' ' + this.formatDate(endDate);
    this.schedulingService.getAppointmentsMinimum(LOCID, dateRange).subscribe((appts) => {
      this.appointments = appts;
      this.daysToHighlight = this.appointments.map(p => {
        const date = new Date(p.StartDate);
        return date.getDate();
      });
    });
  }
}
